// Foto del telefono più leggere prima dell'invio (prova in produzione 2026-09-29: cinque
// foto a piena risoluzione = ~40 s di caricamento da rete mobile, 8-9 s ciascuna, con la
// chat vuota). Il lato lungo scende al massimo a LATO_MAX px: su una bolletta A4 sono circa
// 250 punti per pollice, ancora ben leggibili per l'OCR. I PDF non si toccano; se il
// browser non sa ridimensionare, o il risultato non è più piccolo, parte l'originale.

export const LATO_MAX = 2560;
const QUALITA = 0.85;

export async function comprimiFoto(file: File): Promise<File> {
  if (!file.type.startsWith("image/") || typeof createImageBitmap !== "function") return file;
  try {
    const img = await createImageBitmap(file);
    const scala = Math.min(1, LATO_MAX / Math.max(img.width, img.height));
    const w = Math.round(img.width * scala);
    const h = Math.round(img.height * scala);
    const canvas = document.createElement("canvas");
    canvas.width = w;
    canvas.height = h;
    const ctx = canvas.getContext("2d");
    if (!ctx) return file;
    ctx.drawImage(img, 0, 0, w, h);
    img.close?.();
    const blob = await new Promise<Blob | null>((ok) => canvas.toBlob(ok, "image/jpeg", QUALITA));
    if (!blob || blob.size >= file.size) return file;
    const nome = file.name.replace(/\.[^.]+$/, "") + ".jpg";
    return new File([blob], nome, { type: "image/jpeg" });
  } catch {
    return file;
  }
}
